<template>
    <section class="search-title inline bg-default" :data-count="msp.totalCount || 0">
        <div class="grid gap-0 xs-grid-cols-1">

            <h1 class="text-bold f4 m-y-s">
                <b v-html="fetchH1"></b>
                <a class="link f4" v-if="glb.webpush" :href="notificationUrl" v-html="fetchH1Notification"></a>
            </h1>
            <div class="lh-normal flex search-list-label">
                <div v-if="msp.totalCount" class="truncated">
                    {{$filters.formatNumber(msp.totalCount)}} {{molang('search.seo.homes')}}
                </div>
                <span v-else>{{molang('search.common.noHomes')}}</span>
                <template v-if="componentMounted">
                    <searchSort class="small toggle m-l-auto" :class="{'hide' : !msp.totalCount}"></searchSort>
                </template>
                <template v-if="componentMounted">
                    <a @click="toggleView(!isList)" role="button" :class="{active: isList}" class="btn filter small" v-if="msp.totalCount>0 && !glb.isPhone"><i :class="isList ? 'icon-check-circle-filled' : 'icon-circle' "></i> <span>Compare</span></a>
                </template>
            </div>
        </div>
    </section>
</template>


<script src="./search-title.js"></script>

<style lang="scss">
@use "./search-title.scss" as *;
</style>
